<template>
  <div class="order">
    <summary-view/>
  </div>
</template>

<script>
// @ is an alias to /src
import SummaryView from '@/components/Order/Summary.vue';

export default {
  name: 'order',
  data() {
    return {
    }
  },
  components: {
    'summary-view' : SummaryView,
  },
  mounted() {
    this.load();
  },
  methods: {
    load:function(){
    },
  }
}
</script>

<style scoped>
  .order {
    float:left;
    width: 100%;
    height: 100%;
  }

</style>
